import { render, staticRenderFns } from "./NotificationItemComponent.vue?vue&type=template&id=38e40d27&scoped=true&"
import script from "./NotificationItemComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemComponent.vue?vue&type=style&index=0&id=38e40d27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e40d27",
  null
  
)

export default component.exports